// Utility to attempt element.play() with retries to avoid AbortError races
export default function safePlay(el, attempts = 6, delay = 60) {
    if (!el || typeof el.play !== 'function') return Promise.reject(new Error('no-element'));
    let tries = 0;
    return new Promise((resolve, reject) => {
        const tryOnce = () => {
            tries += 1;
            let p;
            try { p = el.play(); } catch (err) { p = Promise.reject(err); }
            if (!p || !p.then) return resolve();
            p.then(resolve).catch((err) => {
                const isAbort = err && (err.name === 'AbortError' || /AbortError/.test(String(err)));
                if (isAbort && tries < attempts) {
                    setTimeout(tryOnce, delay);
                    return;
                }
                reject(err);
            });
        };
        tryOnce();
    });
}
